export const getHtmlDirection = (languages, locale) => {
  const pageTextDirection = languages?.find(
    e => e.code === locale,
  )?.pageTextDirection;
  const htmlDir = pageTextDirection === "RIGHT" ? "rtl" : "ltr";
  return htmlDir;
};
